import React, { useState } from "react";
import "./CustomModal.css"; 

const CustomModal = ({ show, title, text,text2="",text3="", icon, onClose }) => {
  if (!show) return null;

  return (
    <div className="custom-modal-overlay">
      <div className={`custom-modal custom-modal-${icon}`}>
        <div className="custom-modal-icon">{icon && <span>{icon}</span>}</div>
        <h2 className="custom-modal-title">{title}</h2>
         {text && <p className="custom-modal-text">{text}</p>}
        {text2 && <p className="custom-modal-text">{text2}</p>}
        {text3 && <p className="custom-modal-text">{text3}</p>}
        <button className="custom-modal-btn" onClick={onClose}>
          OK
        </button>
      </div>
    </div>
  );
};

// Example usage
export const ModalPlayground = () => {
  const [showModal, setShowModal] = useState(false);
  const [modalConfig, setModalConfig] = useState({
    title: "",
    text: "",
    text2:"",
    text3:"",
    icon: "⚠️",
  });

  const openModal = (icon, title, text) => {
    setModalConfig({ icon, title, text });
    setShowModal(true);
  };

  return (
    <div>
      <button
        onClick={() =>
          openModal("✅", "Success!", "This is a custom modal like SweetAlert2.")
        }
      >
        Show Success Modal
      </button>

      <button
        onClick={() =>
          openModal("⚠️", "Warning!", "You can play with styles easily.")
        }
      >
        Show Warning Modal
      </button>

      <CustomModal
        show={showModal}
        title={modalConfig.title}
        text={modalConfig.text}
        text2={modalConfig.text2}
        text3={modalConfig.text3}
        icon={modalConfig.icon}
        onClose={() => setShowModal(false)}
      />
    </div>
  );
};

export default CustomModal;